import constants from '../constants/actionTypes';

var initialState = {
  domainName: '',
  domainsLoaded: { isLoaded: false },
  domainList: [],
  domainProviderUnavailable: false,
  suggestions: '',
  isDomainResultsOpen: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.WORD_SUGGESTIONS:
      return {
        ...state,
        suggestions: action.results,
      };

    case constants.DOMAIN_NAME_CHECK_LOADING:
      return {
        ...state,
        domainsLoaded: { isLoaded: false },
        domainProviderUnavailable: false,
      };

    case constants.DOMAIN_NAME_CHECK:
      return {
        ...state,
        domainList: action.results,
        domainsLoaded: { isLoaded: true },
        domainProviderUnavailable: !!action.providerUnavailable,
      };

    case constants.TOGGLE_DOMAIN_RESULTS:
      return {
        ...state,
        isDomainResultsOpen: !state.isDomainResultsOpen,
      };

    default:
      return state;
  }
};